module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "task-overview-page"
  }, [_c('div', {
    staticClass: "user-tasks__header no-print"
  }, [_c('div', {
    staticClass: "user-tasks__header__left"
  }, [_c('h2', {
    staticClass: "user-tasks__header__left__inner"
  }, [(!_vm.isCanSeeOtherUsers) ? _c('h2', [_vm._v(_vm._s(_vm.viewedUser.name))]) : _c('SelectUser', {
    attrs: {
      "preSelectedUserId": _vm.user_id,
      "userName": _vm.user_name,
      "path": "tasks"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "no-mobile"
  }, [_vm._v("-")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('vue2.task_overview.task_overview')))])], 1), _vm._v(" "), _c('ChangeSchoolYear', {
    attrs: {
      "whiteTheme": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "user-tasks__header__right"
  }, [(_vm.viewedUser && _vm.canUserSeeVersions) ? _c('TaskOverviewVersions', {
    attrs: {
      "user": _vm.viewedUser
    }
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "no-mobile marg-1-left",
    on: {
      "click": _vm.print
    }
  }, [_c('span', {
    staticClass: "icon-printer3"
  })])], 1)]), _vm._v(" "), _c('TaskOverviewLive', {
    attrs: {
      "user": _vm.viewedUser
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f2c2691e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/TaskOverview/TaskOverviewPage.vue
// module id = 2163
// module chunks = 1